var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHairDryer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.373V5.98498C21 5.23398 20.444 4.59898 19.7 4.49798L8.921 3.04798C5.787 2.62598 3 5.06298 3 8.22498V8.22498C3 11.405 5.817 13.847 8.965 13.396L19.713 11.857C20.451 11.752 21 11.119 21 10.373Z",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8429 6.93657C10.5263 7.61999 10.5263 8.72803 9.8429 9.41144C9.15948 10.0949 8.05144 10.0949 7.36803 9.41144C6.68461 8.72803 6.68461 7.61998 7.36803 6.93657C8.05145 6.25316 9.15949 6.25316 9.8429 6.93657",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 4.31V12.03",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00195 13.299C7.24895 15.03 7.58295 17.363 7.81695 19.006C7.98095 20.152 8.96195 21 10.12 21V21C11.535 21 12.623 19.75 12.423 18.349C12.176 16.617 11.919 14.82 11.66 13.011",
    stroke: "black",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHairDryer);
export default __webpack_public_path__ + "static/media/hairDryer.7656378eba7ad555dfcd01a8374a8a4e.svg";
export { ForwardRef as ReactComponent };